/* eslint-disable */
import React from "react";
import "./styles.scss";
import Paper from "@mui/material/Paper/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getCityById, getPricingPlans } from "../../../actions/cities";
import { CITY_ID, CITY_NAME, CITY_STATUS } from "../../../constants/orderConst";
import { INTROS_ROUTE, WARNINGS_ROUTE } from "../../../constants/routes";
import { strings } from "../../../I18n";
import { useStyles } from "../../../utils/styles";
import { sortedItem } from "../../../utils/utils";
import TableHeaderRow from "../../table/tableHeaderRow";
import TableItemRow from "../../table/tableItemRow";
import TabletPaginator from "../../table/tabletPaginator";

function CityItem(props) {
  const { cities, citiesResult, handleChangePage, orderProps, setClickedCity } =
    props;
  const classes = useStyles();

  const showCityInfo = (city) => props.getCityById(city.id);
  const showPricingPlan = (city) => {
    setClickedCity(city);
    props.getPricingPlans(city.id);
  };

  const titles = [
    "",
    strings("descriptions.id"),
    strings("descriptions.name"),
    strings("descriptions.color"),
    strings("descriptions.status"),
    strings("descriptions.vat").toUpperCase() + ", %",
    strings("descriptions.pricingPlans"),
    strings("title.intros"),
    strings("title.warnings"),
  ];

  const cityColor = (city) => (
    <div className={"colorContainer"}>
      <p>{city ? city.color : strings("descriptions.color")}</p>
      <div className={"colorBox"} style={{ backgroundColor: city?.color }} />
    </div>
  );

  const edit = React.useCallback(
    (city) => (
      <div className={"edit"} onClick={() => showCityInfo(city)}>
        <div className={"cityLink"} style={{ padding: 5 }}>
          {strings("descriptions.edit")}
        </div>
      </div>
    ),
    []
  );
  const pricingPlans = React.useCallback((city) => {
    setClickedCity(city);
    return (
      <div className={"edit"} onClick={() => showPricingPlan(city)}>
        <div className={"cityLink"} style={{ padding: 5 }}>
          {strings("descriptions.show")}
        </div>
      </div>
      // eslint-disable-next-line react-hooks/exhaustive-deps
    );
  }, []);

  const introsLink = (city) => {
    return (
      <Link
        to={INTROS_ROUTE.replace(":code", city.code)}
        target={"_blank"}
        style={{ fontSize: 14 }}
      >
        Intros
      </Link>
    );
  };

  const warningsLink = (city) => {
    return (
      <Link
        to={WARNINGS_ROUTE.replace(":code", city.code)}
        target={"_blank"}
        style={{ fontSize: 14 }}
      >
        Rental warnings
      </Link>
    );
  };

  const sortedFields = [
    sortedItem(1, CITY_ID, orderProps),
    sortedItem(2, CITY_NAME, orderProps),
    sortedItem(4, CITY_STATUS, orderProps),
  ];

  const tabletBody = () => (
    <TableBody>
      {cities.map((city) => (
        <TableItemRow
          key={city.id}
          id={city.id}
          items={[
            edit(city),
            city.id,
            city.name,
            cityColor(city),
            city.status,
            city.vat,
            pricingPlans(city),
            introsLink(city),
            warningsLink(city),
          ]}
        />
      ))}
    </TableBody>
  );

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <TableContainer>
          <Table className={classes.table} aria-label="simple table">
            <TableHeaderRow items={titles} sortedIndexes={sortedFields} />
            {tabletBody()}
          </Table>
        </TableContainer>
        <TabletPaginator
          items={cities}
          pageData={citiesResult}
          handleChangePage={handleChangePage}
        />
      </Paper>
    </div>
  );
}

const mapDispatchToProps = {
  getCityById,
  getPricingPlans,
};

export default connect(null, mapDispatchToProps)(CityItem);
